import React from 'react'
import { AppButtonIcon, AppRetailerBlock } from '@components'
import { Box } from '@mui/material'
import { dsColorNew } from '@palette'

export default function websiteColumn() {
	return {
		name: "id_site_translation",
		label: "Website",
		options: {
			setCellProps: () => ({ sx: { minWidth: "200px" } }),
			customBodyRowRenderLite: (value, { siteMarket, siteIco, search_url, screenshot }) => {
				return (
					<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
						<AppRetailerBlock retailer={value} icon={siteIco} country={siteMarket} />
						<ButtonComponent icon="up-right-from-square" tooltip="Link to Website" url={search_url} />
						<ButtonComponent icon="image" tooltip="Screenshot" url={screenshot} />
					</Box>
				)
			},
		},
	}
}

// Small and grey as the table's own icons, app blue on hover
function ButtonComponent({ icon, tooltip, url }) {
	if(!url) return null

	return <AppButtonIcon
		iconProps={{ sx: { color: dsColorNew.textMuted } }}
		sx={{ fontSize: 12, p: 0.75, ml: 0.25, '&:hover *': { color: `${dsColorNew.appBlue} !important` } }}
		icon={icon}
		tooltip={tooltip}
		onClick={(e) => {
			window.open(url, "_blank")
			if (e.ctrlKey) e.preventDefault()
		}}
		onAuxClick={(e) => {
			if (e.button === 1) {
				window.open(url)
				e.preventDefault()
			}
		}}
	/>
}
